// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jYrB91sxlHwcDF {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  max-width: 224px;
  margin-bottom: var(--ds-space-050, 4px);
  padding: var(--ds-space-025, 2px);
  gap: var(--ds-space-050, 4px);
}
.jYrB91sxlHwcDF ._kNIkujI2teCAC {
  padding: var(--ds-space-025, 2px) var(--ds-space-050, 4px);
  color: var(--ds-text-subtle, #44546f);
}
.jYrB91sxlHwcDF ._kNIkujI2teCAC .g4fc7KOZ4OQKuL,
.jYrB91sxlHwcDF ._kNIkujI2teCAC .O7drKCoZomYdUl {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  margin-bottom: var(--ds-space-0, 0);
  color: var(--ds-text-subtle, #44546f);
  font-size: 11px;
  line-height: 12px;
  white-space: nowrap;
}
.jYrB91sxlHwcDF ._kNIkujI2teCAC .UITTI7n3iBziJg {
  display: flex;
  align-items: center;
}
.jYrB91sxlHwcDF ._kNIkujI2teCAC .O7drKCoZomYdUl {
  margin-top: var(--ds-space-0, 0);
  font-weight: var(--ds-font-weight-regular, 400);
}
.jYrB91sxlHwcDF:focus-within {
  outline: none;
}
.Q8mesESPnD8FJa {
  height: 14px;
  border-radius: var(--ds-border-radius-200, 6px);
}
.uMKPwVApIVsP_X {
  height: 24px;
  border-radius: var(--ds-border-radius-200, 8px);
}
._8qKnDZ7Zco4DB {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
._8qKnDZ7Zco4DB ._kNIkujI2teCAC {
  display: flex;
  flex-direction: column;
}
._8qKnDZ7Zco4DB ._kNIkujI2teCAC .g4fc7KOZ4OQKuL {
  font-weight: var(--ds-font-weight-bold, 700);
}
._8qKnDZ7Zco4DB:hover {
  background-color: var(--ds-background-accent-gray-subtlest-hovered, #dcdfe4);
  text-decoration: none;
}
.axWLqZ5AxxcKdO ._kNIkujI2teCAC {
  display: flex;
}
.axWLqZ5AxxcKdO ._kNIkujI2teCAC .UITTI7n3iBziJg p {
  font-weight: var(--ds-font-weight-regular, 400);
}
.qg4PGIFOoSpOr8 {
  display: none;
  position: relative;
  bottom: var(--ds-space-050, 4px);
  max-height: 10px;
}
.XjWPEi1dkFJxII {
  display: flex;
  align-items: center;
}
.jYrB91sxlHwcDF:hover .qg4PGIFOoSpOr8 {
  display: flex;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardFrontBoardChip": `jYrB91sxlHwcDF`,
	"names": `_kNIkujI2teCAC`,
	"boardNameText": `g4fc7KOZ4OQKuL`,
	"listName": `O7drKCoZomYdUl`,
	"boardName": `UITTI7n3iBziJg`,
	"compact": `Q8mesESPnD8FJa`,
	"expanded": `uMKPwVApIVsP_X`,
	"showListName": `_8qKnDZ7Zco4DB`,
	"free": `axWLqZ5AxxcKdO`,
	"externalLinkIcon": `qg4PGIFOoSpOr8`,
	"boardChipContents": `XjWPEi1dkFJxII`
};
export default ___CSS_LOADER_EXPORT___;
